var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.companyId)?_c('CompanyEdit',{attrs:{"company-id":_vm.companyId,"super-admin":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }